export default __webpack_public_path__ + "assets/images/a52f82455b95e0f94641ca6e7939245c.svg";